import React from 'react'
import { useSelector } from 'react-redux'

import { setDateRange } from 'slices/filters'
import { RootState } from 'typesafe-actions'

import { H3 } from '@driftt/tide-core'

import AccountSyncFromSalesforcePanel from 'components/AccountSyncFromSalesforcePanel'
import { DateRangePicker } from 'components/DateRangePicker'
import { Header, Navigation } from 'components/Header'
import { useAppDispatch, useAppSelector } from 'hooks/useRedux'
import { getIntegration } from 'modules/users/selectors'

import styles from './styles.module.css'

export const AccountActivityHeader = ({
  title,
  navigation,
  showDateRange = true
}: {
  title: string
  content?: React.ReactElement
  navigation?: Navigation
  showDateRange?: boolean
}) => {
  const dispatch = useAppDispatch()
  const dateRange = useAppSelector(({ filters: { dateRange } }) => dateRange)
  const isSalesforceConnected = useSelector<RootState, any>(getIntegration('salesforce'))

  const filter = (
    <div className={styles.filters}>
      <div className={styles.rightSideHeaderOptions}>
        <div className={styles.marginRight}>
          {isSalesforceConnected && <AccountSyncFromSalesforcePanel />}
        </div>
        {showDateRange && (
          <DateRangePicker
            onDateRangeChange={date => {
              dispatch(setDateRange(date))
            }}
            dateRange={dateRange}
          />
        )}
      </div>
    </div>
  )

  const header = (
    <div className={styles.headerTitle}>
      <H3 className={styles.title}>{title}</H3>
    </div>
  )

  return (
    <Header
      title={title}
      header={header}
      content={filter}
      contentClassName={showDateRange ? styles.datePickerSavedViews : undefined}
      navigation={navigation}
    />
  )
}
